import { useState, useEffect, useId } from 'react'
import InputMask from 'react-input-mask'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import classes from './Textbox.module.scss'
import Debounce from './Debounce'

const TextBox = ({
  Regular,
  RxgMessage,
  className,
  id,
  innerText,
  isRequired,
  msgValidate,
  name,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  value,
  isReadOnly,
  Type,
  isLtR,
  raytebValue,
  debounceTime,
  onClick,
  mask,
  autoComplete,
  autoFocus,
  disabled,
  setRef,
}: TextBoxInterface) => {
  const [validate, setValidate] = useState(0)
  const [text, setText] = useState<string | undefined>(value)

  if (!id) id = useId!()

  useEffect(() => {
    if (value !== undefined && value !== null) setText(value)

    if (isRequired) {
      if (!value) {
        setValidate(3)
        return
      } else setValidate(2)
    }

    if (Regular && isRequired) {
      const reg = new RegExp(Regular)
      if (!value || !reg.exec(value)) {
        setValidate(1)
      } else {
        setValidate(2)
      }
      return
    }
  }, [value])
  const change = (event) => {
    setText(event.target.value)
    if (isRequired) {
      if (!event.target.value) {
        setValidate(3)
        return
      } else setValidate(2)
    }
    if (Regular) {
      const reg = new RegExp(Regular)
      if (!reg.exec(event.currentTarget.value)) {
        setValidate(1)
        return
      } else {
        setValidate(2)
      }
    }
    onChange &&
      Debounce({
        func: () => onChange(event),
        timeout: debounceTime !== undefined ? debounceTime : 800,
      })
  }
  const isMaskable = (): boolean => {
    return (
      Type === TextBoxTypeEnum.Mobile ||
      Type === TextBoxTypeEnum.Time ||
      Type === TextBoxTypeEnum.PrintCode
    )
  }
  const getMask = (): string => {
    switch (Type) {
      case TextBoxTypeEnum.Time: {
        return '99:99'
      }
      case TextBoxTypeEnum.Mobile: {
        return '99999999999'
      }
      case TextBoxTypeEnum.PrintCode: {
        return mask ?? '99999'
      }
    }
    return ''
  }

  return (
    <>
      <div className='relative h-auto w-full'>
        {isMaskable() && (
          <InputMask
            mask={getMask()}
            alwaysShowMask={true}
            onFocus={onFocus}
            onBlur={(e) => {
              setTimeout(() => {
                onBlur?.(e)
              }, 100)
            }}
            disabled={disabled}
            onKeyDown={onKeyDown}
            onChange={change}
            value={text ?? ''}
            id={id}
            readOnly={isReadOnly}
          >
            <input
              autoFocus={autoFocus}
              dir={isLtR ? 'ltr' : 'rtl'}
              rayteb-value={raytebValue}
              onClick={(e) => {
                onClick?.(e)
              }}
              ref={setRef}
              autoComplete='off'
              rayteb-reqvalid={`${isRequired && validate !== 2}`}
              rayteb-reqmessage={
                RxgMessage && validate === 1
                  ? RxgMessage
                  : msgValidate
                    ? msgValidate
                    : `${innerText} نمیتواند خالی باشد`
              }
              className={`peer border w-100% block px-2.5 rounded-md py-2 min-h-[33px]  relative
          text-xs  bg-transparent 
               focus:outline-none focus:ring-1
               focus:ring-disable w-full

               ${validate === 1 || validate === 3 ? 'border-2' : ''}

               ${validate === 0
                  ? 'border-disable'
                  : validate === 1 || validate === 3
                    ? '!border-[#dc3545]'
                    : '!border-[#28a745]'
                } ${className ? className : ''}`}
              name={name}
            />
          </InputMask>
        )}
        {!isMaskable() && (
          <input
            autoFocus={autoFocus}
            onFocus={onFocus}
            onBlur={(e) => {
              setTimeout(() => {
                onBlur?.(e)
              }, 100)
            }}
            rayteb-value={raytebValue}
            rayteb-reqvalid={`${isRequired && validate !== 2}`}
            rayteb-reqmessage={
              RxgMessage && validate === 1
                ? RxgMessage
                : msgValidate
                  ? msgValidate
                  : `${innerText} نمیتواند خالی باشد`
            }
            onKeyDown={onKeyDown}
            onChange={change}
            disabled={disabled}
            autoComplete={autoComplete ?? 'off'}
            onClick={(e) => {
              onClick?.(e)
            }}
            type={Type}
            id={id}
            value={text ?? ''}
            ref={setRef}
            readOnly={isReadOnly}
            className={`peer border w-100% block px-2.5 rounded-md py-1 min-h-[36px]  relative
          text-xs  bg-transparent 
               focus:outline-none focus:ring-1
               focus:ring-disable w-full

               ${validate === 1 || validate === 3 ? 'border-2' : ''}

               ${validate === 0
                ? 'border-disable'
                : validate === 1 || validate === 3
                  ? '!border-[#dc3545]'
                  : '!border-[#28a745]'
              } ${className ? className : ''}`}
            placeholder={' '}
            name={name}
            dir={isLtR ? 'ltr' : 'rtl'}
          />
        )}
        <label
          htmlFor={id}
          rayteb-text={innerText}
          className={`${classes['label']} 
              before:!pr-1 before:peer-focus:!pr-1      
           ${text
              ? 'before:bg-gradient-to-t before:!to-primaryDefault2 before:!from-white !before:text-primary '
              : ''
            } ${isMaskable()
              ? 'before:bg-gradient-to-t before:!to-primaryDefault2 before:!from-white'
              : 'before:bg-white'
            }  before:translate-x-0 before:bg-gradient-to-t before:peer-focus:to-primaryDefault2 before:peer-focus:from-white
           before:peer-placeholder-shown:bg-inherit before:px-2  before:peer-focus:font-bold before:peer-placeholder-shown:scale-100 before:peer-placeholder-shown:-translate-y-1/2
            before:peer-placeholder-shown:top-1/2 before:peer-focus:top-0 before:peer-focus:scale-[0.80] 
            before:peer-focus:-translate-y-3  before:peer-focus:text-primary
            before:peer-placeholder-shown:translate-x-1 
             
              `}
        ></label>
        <p
          style={{ lineHeight: '13px' }}
          className={`text-[#dc3545] absolute top-full mt-1 pr-2 text-[10px]  ${validate === 3 || validate === 1 ? 'visible' : 'invisible'
            }`}
        >
          {RxgMessage && validate === 1
            ? RxgMessage
            : msgValidate
              ? msgValidate
              : `${innerText} نمیتواند خالی باشد`}
        </p>
      </div>
    </>
  )
}

export default TextBox
